// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/connectors/ConnectorOwnerPanel.jsx

import React from "react";
import { StatusChip } from "../../../design-system/components";

export default function ConnectorOwnerPanel({ connector }) {
  const ownerName = connector?.owner?.name || connector?.owner_name || "No owner assigned";
  const ownerEmail = connector?.owner?.email || connector?.owner_email || "";
  const ownerDetail = ownerEmail || (connector?.owner_name
    ? "Accountable connector owner"
    : "Assign an accountable owner for this connected system.");
  const assigned = Boolean(connector?.owner_name || connector?.owner?.name);

  return (
    <section className="enterprise-admin-detail-section enterprise-admin-connector-owner-panel">
      <p className="enterprise-admin-eyebrow">Ownership</p>
      <div className="enterprise-admin-assigned-role-card enterprise-admin-connector-owner-card">
        <div>
          <strong>{ownerName}</strong>
          <span>{ownerDetail}</span>
        </div>
        <StatusChip tone={assigned ? "neutral" : "warning"}>
          {assigned ? "Primary" : "Unassigned"}
        </StatusChip>
      </div>
    </section>
  );
}
